import { IsNumber, IsOptional, IsPositive, Max } from "class-validator";

export class RemoveCourseSessionRegistrationDto {
  // Club points to credit the registrant (1000 points = $1). Omitted/0 = no credit.
  @IsOptional()
  @IsNumber()
  @IsPositive()
  @Max(500000) // Max 500,000 points (=$500), matches the wallet award cap
  credit_points?: number;
}
